<mojo-viewbar></mojo-viewbar>
<mojo-page-title [title]="title$ | async"></mojo-page-title>

<section class="full-page-scrollable">
  <div class="panel resizable-page-widget">
    <div class="panel-body">
      <div *ngIf="(loading$ | async); else sysConfigFormContainer">
        <p-progressSpinner></p-progressSpinner>
      </div>

      <ng-template #sysConfigFormContainer>
        <p-accordion [multiple]="true">

          <form [formGroup]="configForm" (ngSubmit)="submit()" class="validated-form" name="sysConfigForm"
                id="sysConfigForm" #sysConfigForm="ngForm">
            <!-- General Settings -->
            <p-accordionTab header="General Information">
              <div class="ui-grid ui-grid-responsive ui-fluid" formGroupName="BrandInformation">
                <div class="field grid form-group">
                  <label class="col-fixed" for="application-name">Application Name</label>
                  <div class="col-fixed inputfield">
                    <input class="form-control" name="application-name" id="application-name" pInputText
                           formControlName="applicationName"/>
                    <div class="config-validation-message"
                         [hidden]="!configForm.controls['BrandInformation']?.controls['applicationName']?.errors?.required">
                      Application Name is required.
                    </div>
                    <div class="config-validation-message"
                         [hidden]="!configForm.controls['BrandInformation']?.controls['applicationName']?.errors?.maxlength">
                      Must be shorter than 150 characters
                    </div>
                  </div>
                </div>

                <div class="field grid form-group">
                  <label class="col-fixed" for="support-telephone">Support Tel. No.</label>
                  <div class="col-fixed inputfield">
                    <input class="form-control" name="support-telephone" id="support-telephone" pInputText
                           formControlName="supportTelNo"/>
                    <div class="config-validation-message"
                         [hidden]="!configForm.controls['BrandInformation']?.controls['supportTelNo']?.errors?.required">
                      Support Tel. No. is required.
                    </div>
                    <div class="config-validation-message"
                         [hidden]="!configForm.controls['BrandInformation']?.controls['supportTelNo']?.errors?.maxlength">
                      Must be shorter than 100 characters
                    </div>
                  </div>
                </div>

                <div class="field grid form-group">
                  <label class="col-fixed" for="support-email-signature">Email Signature</label>
                  <div class="col-fixed inputfield">
                    <input class="form-control" name="support-email-signature" id="support-email-signature" pInputText
                           formControlName="emailSignature"/>
                    <div class="config-validation-message"
                         [hidden]="!configForm.controls['BrandInformation']?.controls['emailSignature']?.errors?.required">
                      Email Signature is required.
                    </div>
                    <div class="config-validation-message"
                         [hidden]="!configForm.controls['BrandInformation']?.controls['emailSignature']?.errors?.maxlength">
                      Must be shorter than 250 characters
                    </div>
                  </div>
                </div>

                <div class="field grid form-group">
                  <label class="col-fixed" for="product-url">Support Email</label>
                  <div class="col-fixed inputfield">
                    <input class="form-control" name="support-email" id="support-email" pInputText
                           formControlName="supportEmailAddress"/>
                    <div class="config-validation-message"
                         [hidden]="!configForm.controls['BrandInformation']?.controls['supportEmailAddress']?.errors?.required">
                      Support Email is required.
                    </div>
                    <div class="config-validation-message"
                         [hidden]="!configForm.controls['BrandInformation']?.controls['supportEmailAddress']?.errors?.maxlength">
                      Must be shorter than 150 characters
                    </div>
                  </div>
                </div>

                <div class="field grid form-group">
                  <label class="col-fixed" for="product-url">Company Website</label>
                  <div class="col-fixed inputfield">
                    <input class="form-control" name="company-website" id="company-website" pInputText
                           formControlName="companyWebSite"/>
                    <div class="config-validation-message"
                         [hidden]="!configForm.controls['BrandInformation']?.controls['companyWebSite']?.errors?.required">
                      Company Website is required.
                    </div>
                    <div class="config-validation-message"
                         [hidden]="!configForm.controls['BrandInformation']?.controls['companyWebSite']?.errors?.maxlength">
                      Must be shorter than 150 characters
                    </div>
                  </div>
                </div>

              </div>
            </p-accordionTab>
            <!-- Overview Settings -->
            <p-accordionTab header="Overview Configuration" *ngIf="showOverviewConfigurationSettings()">
              <div class="ui-grid ui-grid-responsive ui-fluid" formGroupName="OverviewConfig">
                <div class="field grid">
                  <label class="col-fixed" for="selectedTiles">Tiles</label>
                  <div class="col-fixed dropdown-field">
                    <p-multiSelect formControlName="selectedTiles" [options]="selectableTiles" defaultLabel="Choose"
                                   selectedItemsLabel="{0} items selected">
                    </p-multiSelect>
                  </div>
                </div>
              </div>
            </p-accordionTab>
            <!-- Lister Configuration -->
            <p-accordionTab header="Lister Configuration">
              <div formGroupName="ListerConfiguration">
                <lister-configuration [listerPages]="allTiles" [productName]="productName"
                                      formControlName="config"></lister-configuration>
              </div>
            </p-accordionTab>

          </form>

        </p-accordion>

        <div class="button-bar ui-dialog-buttonpane ui-helper-clearfix text-center">
          <button id="save-button" type="button" [disabled]="!configForm.valid || configForm.pristine" pButton
                  (click)="submit()" label="Save"></button>
          <button id="cancel-button" type="button" pButton (click)="cancel()" label="Cancel"></button>
        </div>

      </ng-template>
    </div>
  </div>
</section>

